document.addEventListener("DOMContentLoaded", function () {
  const monthly_hours = document.querySelector("#monthly-hours");
  if (monthly_hours) {
    const select_hours = "#time_hours";
    const select_minutes = "#time_minutes";
    const total_id = "#monthly-hours #value";

    // Calculate the total duration of all monthly hours input
    const calculate_total = () => {
      let number_hours = 0;
      let number_minutes = 0;
      for (let select of document.querySelectorAll(select_hours)) {
        number_hours = number_hours + parseInt(select.value || 0);
      }
      for (let select of document.querySelectorAll(select_minutes)) {
        number_minutes = number_minutes + parseInt(select.value || 0);
      }

      let display_hours = number_hours + Math.trunc(number_minutes / 60);
      let display_minutes = ("00" + (number_minutes % 60)).slice(-2);
      document.querySelector(total_id).textContent = `${display_hours}h ${display_minutes}min`;
    };
    calculate_total();

    for (let select of document.querySelectorAll(select_hours)) {
      select.addEventListener("change", calculate_total);
    }
    for (let select of document.querySelectorAll(select_minutes)) {
      select.addEventListener("change", calculate_total);
    }

    // Jquery event need jquery listener
    $(document).on("dynamic_list_changed", ".dynamic-list", (_e, change) => {
      // When adding a new row, the new selects need the event listeners
      if (change.added) {
        const new_select_hours = change.added[0].querySelector(select_hours);
        new_select_hours.value = 0;
        const new_select_minutes = change.added[0].querySelector(select_minutes);
        new_select_minutes.value = 0;
        new_select_hours.addEventListener("change", calculate_total);
        new_select_minutes.addEventListener("change", calculate_total);
      }

      // When a row is deleted, the select time need to trigger a new calculation
      calculate_total();
    });
  }
});
